<template>
  <v-card>
    <v-card-title
      v-if="round && round.id != 0"
      primary-title
      class="headline gradiente lighten-2 elevation-3"
    >
      <v-avatar v-if="round.imageStorage && round.imageStorage.miniObjUrl" size="90">
        <v-img :src="round.imageStorage.miniObjUrl"></v-img>
      </v-avatar>
      <v-icon v-else large dark>group_work</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;
      <span class="white--text">{{ round.name }}</span>
    </v-card-title>
    <v-layout row wrap v-if="round && round.id != 0">
      <v-container grid-list-xs>
        <v-layout row wrap>
          <v-flex xs2 text-xs-center>
            <v-avatar
              v-if="round.parent.imageStorage && round.parent.imageStorage.miniObjUrl"
              size="90"
            >
              <v-img :src="round.parent.imageStorage.miniObjUrl"></v-img>
            </v-avatar>
            <v-icon v-else large>person</v-icon>
          </v-flex>
          <v-flex xs10>
            <h2>{{ round.parent.firstName + ' ' + round.parent.lastName }}</h2>
            <v-divider></v-divider>
            <v-flex xs12 v-for="(student, key) in round.students" :key="key">
              <v-chip>
                <v-avatar v-if="student.imageStorage && student.imageStorage.miniObjUrl">
                  <img :src="student.imageStorage.miniObjUrl" />
                </v-avatar>
                <v-icon v-else>school</v-icon>
                {{ student.firstName + ' ' + student.lastName }}
              </v-chip>
            </v-flex>
          </v-flex>
          <v-divider></v-divider>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout v-else-if="!round" row wrap>
      <v-flex xs12 text-xs-center>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-alert :value="true" type="error">Al parecer ocurrió un error. Inténta de nuevo más tarde</v-alert>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close">Cerrar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["round"],
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
</style>